export enum DocumentStatusesEnum{
    Completed="completed",
    Viewed='viewed',
    Signed='signed',
    Delivered='delivered',
    Approved='approved',
    Revoke='revoked',
    Draft='draft',
    Uploaded='uploaded',
    Expired ='expired',
    Sent ='sent',
    Rejected = 'rejected',
    Failed ='failed',
    Forwarded = 'forward',
    Waiting = 'waiting',
    ReadOnly = 'read_only',
    Initiator = 'initiator',
}
